import { useEffect, useRef } from 'react';

export const useInteractivityMetrics = onMetricsReady => {
  const startTime = useRef(performance.now());
  const firstInteractionTime = useRef(null);

  useEffect(
    () => {
      // Marcar cuando la app está lista para interacción
      const userInteractionReady = performance.now() - startTime.current;

      // Escuchar la primera interacción del usuario
      const handleFirstInteraction = e => {
        if (!firstInteractionTime.current) {
          firstInteractionTime.current = performance.now() - startTime.current;

          onMetricsReady({
            userInteractionReady: Math.round(userInteractionReady),
            timeToInteractive: Math.round(firstInteractionTime.current),
          });

          // Remover listeners después de la primera interacción
          ['click', 'touchstart', 'keydown', 'mousemove'].forEach(event => {
            window.removeEventListener(event, handleFirstInteraction);
          });
        }
      };

      ['click', 'touchstart', 'keydown', 'mousemove'].forEach(event => {
        window.addEventListener(event, handleFirstInteraction, { once: true });
      });

      return () => {
        ['click', 'touchstart', 'keydown', 'mousemove'].forEach(event => {
          window.removeEventListener(event, handleFirstInteraction);
        });
      };
    },
    [onMetricsReady],
  );
};
